import { hasExtraPackagingMarkings as j } from "../types/types.js";
import { allContainmentsFreeFrom as p } from "./transformation.js";
import { hasAnyAlcoholData as u } from "./alcohols.js";
const d = (a) => {
  var L, M, S, U, q, B, H, J, K, O, Q, R, T, V, W, X, Y, Z, $, D;
  if (!a)
    return !1;
  const {
    ingredient_list: f,
    ingredient_list_nonfood: l,
    product_ingredient_details: A,
    fish_meat_poultries: m,
    dairy_juice_dry_matter_contents: h,
    fishings: I,
    e_numbers: E,
    allergens: F,
    attributes: o,
    measurements: P,
    names_and_descriptions: k,
    manufacturer: x,
    produced_for: C,
    consumer_support: N,
    licensee_registrar: e,
    countries_of_origin: t,
    product_activities: w,
    responsibilities: n,
    warranties: v,
    packaging_markings: y,
    certifications: z,
    organic_certifications: G
  } = a;
  return !!((M = (L = f == null ? void 0 : f[0]) == null ? void 0 : L.ingredient_list) != null && M.length) || !!((U = (S = l == null ? void 0 : l[0]) == null ? void 0 : S.ingredient_list_nonfood) != null && U.length) || (A == null ? void 0 : A.length) > 0 || !!((H = (B = (q = m == null ? void 0 : m[0]) == null ? void 0 : q.fish_meat_poultry_types) == null ? void 0 : B[0]) != null && H.value) && !!((J = m == null ? void 0 : m[0]) != null && J.minimum_fish_meat_poultry_content) || !!((K = h == null ? void 0 : h[0]) != null && K.fat_percentage_in_dry_matter) || !!((O = h == null ? void 0 : h[0]) != null && O.fat_in_milk_content) || !!((Q = h == null ? void 0 : h[0]) != null && Q.juice_content_percentage) || !!(I != null && I[0]) || !!(E != null && E[0]) || !!(F != null && F[0]) && !p(a) || u(a) || (o == null ? void 0 : o.length) > 0 && o.some(
    (g) => !!g.attribute_name && !!g.attribute_value
  ) || !!(P != null && P[0]) && !!((R = k == null ? void 0 : k[0]) != null && R.descriptive_size) || !!(x != null && x[0]) || !!(C != null && C[0]) || !!(N != null && N[0]) || !!(e != null && e[0]) || !!(t != null && t[0]) || !!(w != null && w[0]) || // !!responsibilities?.[0]?.carbon_foot_print || KDIT-486: Hide Carbon Footprint section for now
  ((T = n == null ? void 0 : n[0]) == null ? void 0 : T.vegan) === "true" || !!((V = n == null ? void 0 : n[0]) != null && V.water_foot_print) || !!((W = n == null ? void 0 : n[0]) != null && W.cbam_product_code) || !!((Y = (X = n == null ? void 0 : n[0]) == null ? void 0 : X.palm_oil_responsibilities) != null && Y[0]) || !!(($ = (Z = n == null ? void 0 : n[0]) == null ? void 0 : Z.soy_responsibilities) != null && $[0]) || !!(v != null && v.length) && v.some((g) => !!g.warranty_period && !!g.warranty_period_uom) || !!(y != null && y.some(
    (g) => {
      var _;
      return j(g) && !!((_ = g.trade_item_date_on_packaging_types) != null && _.length);
    }
  )) || !!(z != null && z.length) || !!((D = G == null ? void 0 : G.filter(
    (g) => g.organic_certification_identification !== "UNSPECIFIED"
  )) != null && D.length);
}, s = (a, f) => a ? !!a.every((l) => {
  l.language === f && l.ingredient_name;
}) : !1;
export {
  s as hasAllIngredientNamesInGivenLanguage,
  d as hasAnyProductInfoData
};
